var render = function render(){var _vm=this,_c=_vm._self._c;return _c('user-agreement',{attrs:{"user-agreement-type":_vm.userAgreementType}})
}
var staticRenderFns = []

export { render, staticRenderFns }